import ChevronDownIconPath from "@ingka/ssr-icon/paths/chevron-down";

export default ChevronDownIconPath;
